<template>
  <section class="sec sec-06 mt-5 mb-5 sec-padding">
    <div class="container-fluid">
      <div class="row">
        <div class="sec-title">
         <h1 class="wow fadeInUp has-u-line" data-wow-duration="1s" data-wow-delay=".1s" v-html="title"></h1>
        </div>
      </div>
      <div class="row justify-content-center">
          <div class="col-lg-8">
              <div class="sec-content">
             <p class="text-center fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">AlphaQ is an absolute algorithmic trading quant that secures you with positive alpha.<br>
Here you can get adapted to an ecosystem where trading is feasible with freedom of time and a minimum learning curve!</p>
        </div>
          </div>
      </div>
    </div>
  </section>
</template>
<style scoped>

</style>
<script>
export default {
   props: {
    title: {
      type: String,
      default: ""
    },
    titleSub:{
      type: String,
      default: ""
    }
  }
  }
</script>